(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/wallet-type/assets/javascripts/wallet-type.js') >= 0) return;  svs.modules.push('/components/tipsen/wallet-type/assets/javascripts/wallet-type.js');
"use strict";


const walletType = {
  WALLET_PLAYER: 'WALLET_PLAYER',
  WALLET_MARKETPLACE_PLAYER: 'WALLET_MARKETPLACE_PLAYER',
  WALLET_MARKETPLACE_RETAILER: 'WALLET_MARKETPLACE_RETAILER',
  WALLET_SELFSERVICE: 'WALLET_SELFSERVICE'
};
setGlobal('svs.components.tipsen.wallet.walletType', walletType);

 })(window);